/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Search_4Inputs */

const en_pc_tut_search_4 = /** @type {(inputs: Pc_Tut_Search_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select and copy text. Selection follows reading order, so columns and right-to-left text copy correctly.`)
};

const zh_pc_tut_search_4 = /** @type {(inputs: Pc_Tut_Search_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择并复制文本。选择遵循阅读顺序，多栏和从右到左的文本都能正确复制。`)
};

/**
* | output |
* | --- |
* | "Select and copy text. Selection follows reading order, so columns and right-to-left text copy correctly." |
*
* @param {Pc_Tut_Search_4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_search_4 = /** @type {((inputs?: Pc_Tut_Search_4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Search_4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_search_4(inputs)
	return zh_pc_tut_search_4(inputs)
});
export { pc_tut_search_4 as "pc.tut.search.4" }